import MessageClient from "./MessageClient";
import Helpers from "../../commons/helpers";
import { Constants } from "../../constants/constants";
import { IPagedList, ITopic, IUserTopic } from "../../commons/interfaces";

export type IRequestGetPagedTopic = {
    clientId?: string;
    serviceCode?: string;
    tenantCode?: string;
    organizationId?: string;
    pageNumber: number;
    pageSize: number;
    orderby?: string;
    searchText?: string;

    totalCount?: number;
};

export type IRequestGetPagedUserTopic = {
    topicId: string;
    pageNumber: number;
    pageSize: number;

    clientId?: string;
    serviceCode?: string;
    tenantCode?: string;
    organizationId?: string;
    orderby?: string;
    searchText?: string;

    totalCount?: number;
};

export type IRequestUpdateTopic = {
    id: string;
    topicName: string;
    description: string;
    clientId: string;
    serviceCode: string;
    tenantCode: string;
    organizationId: string;
};

export type IRequestCreateTopic = Omit<IRequestUpdateTopic, "id">;

const TopicService = {
    getPaged: async (data: IRequestGetPagedTopic): Promise<IPagedList<ITopic>> => {
        const pamams = Helpers.handleFormatParams(data);
        const result = await MessageClient().get(`${Constants.ApiPath.TOPIC.GET_PAGED}?${pamams}`);
        return result.data.result;
    },

    getPagedUserTopic: async (data: IRequestGetPagedUserTopic): Promise<IPagedList<IUserTopic>> => {
        const pamams = Helpers.handleFormatParams(data);
        const result = await MessageClient().get(`${Constants.ApiPath.TOPIC.GET_PAGED_USER_TOPIC}?${pamams}`);
        return result.data.result;
    },

    getDetail: async (id: string): Promise<ITopic> => {
        const result = await MessageClient().get(Constants.ApiPath.TOPIC.GET_DETAIL + `/${id}`);
        return result.data.result;
    },

    create: async (data: IRequestCreateTopic): Promise<ITopic> => {
        const result = await MessageClient().post(Constants.ApiPath.TOPIC.CREATE, data);
        return result.data.result;
    },

    update: async (data: IRequestUpdateTopic): Promise<ITopic> => {
        const result = await MessageClient().post(Constants.ApiPath.TOPIC.UPDATE, data);
        return result.data.result;
    },

    delete: async (id: string) => {
        const result = await MessageClient().delete(Constants.ApiPath.TOPIC.DELETE + `/${id}`);
        return result.data.result;
    },

    subscribe: async (data: { topicId: string; userId: string }) => {
        const result = await MessageClient().post(Constants.ApiPath.TOPIC.SUBSCIBE, data);
        return result.data.result;
    },

    unSubscribe: async (data: { topicId: string; userId: string }) => {
        const result = await MessageClient().delete(Constants.ApiPath.TOPIC.UNSUBSCIBE, { data });
        return result.data.result;
    },

    blockUserTopic: async (data: { topicId: string; userId: string }) => {
        const result = await MessageClient().delete(Constants.ApiPath.TOPIC.BLOCK_USER_TOPIC, { data });
        return result.data.result;
    },
};

export default TopicService;
